/**
 * Created by casteloyee on 2017/7/15.
 */
import React from 'react';
import { Modal, Button, Row, Col, InputNumber, Spin, message } from 'antd';
import API_URL from '../../common/url';
import AjaxRequest from '../../common/AjaxRequest';

class SitePlanModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            plan: {},
            statisticalType: '',
            siteId: '',
            title: '',
            siteCode: '',
            siteName: '',
            sitePlanAmount: '',
            actualAmount:'',
            sitePlanIsEdit: false,
            siteMonthlyPlan: [],
            monthlyPlan: '',
            isGivenSecondLines: false,
        };
    }

    show = (statisticalType, siteId, visitGroupingId) => {
        if ('Type_Filter' == statisticalType) {
            this.setState({
                title: '设置中心筛选计划',
            });
        }
        if ('Type_Informed' == statisticalType) {
            this.setState({
                title: '设置中心知情计划',
            });
        }
        if ('Type_Random' == statisticalType) {
            this.setState({
                title: '设置中心随机(入组)计划',
            });
        }
        this.setState({
            visible: true,
            statisticalType,
            siteId,
            visitGroupingId,
        },()=>{
            this.loadData();
            this.queryInvestigationSecondLines();
        });
    }

    hide = () => {
        this.setState({ visible: false });
        this.props.loadData();
    }

    loadData = (hide) => {
        const { siteId, statisticalType,visitGroupingId } = this.state;
        const options = {
            url: `${API_URL.plan.querySitePlanData}`,
            data: {
                statisticalType,
                invSiteId: siteId,
                visitGroupingId,
            },
            dataType: 'json',
            doneResult: data => {
                const { site, sitePlan, monthlySitePlan } = data.data;
                const siteMonthlyPlan = [];
                monthlySitePlan.map((monthlyPlan, i) => {
                    let ym = monthlyPlan.year + '.' + monthlyPlan.month;
                    siteMonthlyPlan.push({
                        yearMonth: ym,
                        year: monthlyPlan.year,
                        month: monthlyPlan.month,
                        planAmount: monthlyPlan.planAmount,
                        editing: false,
                    });
                });
                this.setState({
                    loadingColumns: false,
                    loadingData: false,
                    plan:sitePlan || [],
                    sitePlanAmount: sitePlan ? sitePlan.planAmount : '',
                    actualAmount: sitePlan ? sitePlan.actualAmount : '',
                    siteMonthlyPlan,
                    siteCode: site.investigationSiteCode,
                    siteName: site.investigationSiteName,
                });
                !monthlySitePlan.length && hide && this.hide();
            },
        };
        AjaxRequest.sendRequest(options);
    }

    queryInvestigationSecondLines = () => {
        //判断是否为执行业务线二级分类为“SSU主导、启动前协助、启动前协助+启动后常规CRC执行、启动后常规CRC执行、非盲”的项目
        const { invId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationSecondLines,
            data: { invId },
            dataType: 'json',
            doneResult: res => {
                const { secondLines, sitePlanFteCal } = res;
                const givenSecondLines = ['SSU主导','启动前协助','启动前协助+启动后常规CRC执行','启动后常规CRC执行','非盲'];
                //const isGivenSecondLines = givenSecondLines.includes(secondLines) && sitePlanFteCal;
                const isGivenSecondLines = givenSecondLines.includes(secondLines);
                this.setState({
                    isGivenSecondLines,
                });
            }
        };
        AjaxRequest.sendRequest(options);
    }

    onInputPlanAmount = value => {
        this.setState({ sitePlanAmount: value });
    }

    onInputBatchPlanAmount = value => {
        const { plan } = this.state;
        plan.batchPlanAmount = value;
        this.setState({ plan });
    }

    onInputMonthlyPlanAmount = (i, value) => {
        const { siteMonthlyPlan } = this.state;
        siteMonthlyPlan[i].planAmount = value;
        this.setState({ siteMonthlyPlan });
    }

    editSitePlan = () => {
        const { sitePlanIsEdit, statisticalType, siteId, sitePlanAmount, visitGroupingId } = this.state;
        if (sitePlanIsEdit) {
            // 保存
            if (sitePlanAmount == null || sitePlanAmount == undefined || sitePlanAmount < 0 || sitePlanAmount === "") {
                Modal.error({ title: '计划数为空或无效' });
                return;
            }
            const options = {
                url: `${API_URL.plan.saveSitePlan}`,
                data: {
                    invSiteId: siteId,
                    planAmount: sitePlanAmount,
                    statisticalType,
                    visitGroupingId,
                },
                dataType: 'json',
                doneResult: () => {
                    this.setState({ sitePlanIsEdit: false },()=>{ this.loadData() });
                },
            };
            AjaxRequest.sendRequest(options);
        } else {
            this.setState({ sitePlanIsEdit: true });
        }
    }

     // 入组周期 的添加更新
     addUpdateMonthly =()=> {
        const { plan, visitGroupingId, siteId, statisticalType } = this.state;
        const { planAmount, batchPlanAmount } = plan ||{};
        if(!planAmount){
            message.error('未设置中心计划数，不可设置入组周期每月计划');
            return; 
        }
        const options = {
            method: 'POST',
            url: API_URL.plan.batchSave,
            data: { 
                invSiteId: siteId,
                planAmount:batchPlanAmount,
                visitGroupingId,
                statisticalType,
             },
            dataType: 'json',
            doneResult: res => {
                if(res && res.error)
                {
                    message.error('更新失败');
                    return;
                }
                this.loadData();
                message.success('更新成功');
            },
        };
        AjaxRequest.sendRequest(options);
    }

    saveDefinePlan = row => {
        const { siteMonthlyPlan, siteId, statisticalType, visitGroupingId } = this.state;
        // 校验是否通过
        const sendParams = {};
        let isVerificationPassed = true;
        siteMonthlyPlan.map((monthlyPlan, index) => {
            if (monthlyPlan.planAmount == null || monthlyPlan.planAmount == undefined || monthlyPlan.planAmount < 0 || monthlyPlan.planAmount === "") {
                isVerificationPassed = false;
                return
            }
            sendParams[`monthlyPlanDtos[${index}].year`] = monthlyPlan.year;
            sendParams[`monthlyPlanDtos[${index}].month`] = monthlyPlan.month;
            sendParams[`monthlyPlanDtos[${index}].planAmount`] = monthlyPlan.planAmount;
        });
        if (!isVerificationPassed) {
            Modal.error({ title: '计划数为空或无效' });
            return;
        }
        this.setState({[`loading${row}`]:true})
            // 保存
            const options = {
                url: `${API_URL.plan.saveSiteMonthlyPlan}`,
                data: {
                    invSiteId: siteId,
                    ...sendParams,
                    statisticalType,
                    visitGroupingId,
                },
                dataType: 'json',
                doneResult: () => {
                    message.success('修改成功');
                    siteMonthlyPlan.map(monthlyPlan => {
                        monthlyPlan.editing = false;
                    });
                    this.setState({ siteMonthlyPlan, [`loading${row}`]:false });
                    this.hide();
                },
                errorResult:()=>{
                    this.setState({ siteMonthlyPlan, [`loading${row}`]:false });
                }
            };
            AjaxRequest.sendRequest(options);
    }

    changeEdit = (value) => {
        const { siteMonthlyPlan } = this.state;
        siteMonthlyPlan.map(monthlyPlan => {
            monthlyPlan.editing = value;
        });
        this.setState({ siteMonthlyPlan });
    }

    render() {
        const { visible, title, siteMonthlyPlan, sitePlanIsEdit, plan, isGivenSecondLines } = this.state;
        const canEdit = siteMonthlyPlan.every(monthlyPlan => monthlyPlan.editing == true);
        return (
            <Modal
                title={title}
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="600px"
                footer={isGivenSecondLines ? canEdit ?[
                    <Button key="cancel" size="large" onClick={()=>this.loadData(true)}>
                        取消
                    </Button>,
                    <Button key="submit" type="primary" size="large" onClick={() => this.saveDefinePlan()}>
                        确定
                    </Button>,
                ] : [
                    <Button key="edit" type="primary" size="large" onClick={() => this.changeEdit(true)}>
                        编辑
                    </Button>,
                ] : [<Button key="submit" type="primary" size="large" onClick={this.hide}>
                        确定
                    </Button>]}
            >
                <Row>
                    <Col span={3} offset={2}>中心编号：</Col>
                    <Col span={4}>{this.state.siteCode}</Col>
                    <Col span={3} offset={2}>中心名称：</Col>
                    <Col span={7}>{this.state.siteName}</Col>
                </Row>
                <div className='box'>
                    <div className='bar'></div>
                    <div className='table'>
                        <Row type="flex" justify="space-around" align="bottom" className='row1'>
                            <Col span={4} offset={4} style={{ paddingBottom: 8 }}>总计划数</Col>
                            <Col span={16}>
                                <Row>
                                    <Col span={10}>时间</Col>
                                    <Col span={6}>计划数</Col>
                                    <Col span={8}>操作</Col>
                                </Row>
                                <Row>
                                    <Col span={10}>-</Col>
                                    <Col span={6}><InputNumber disabled={!sitePlanIsEdit} min={0} max={100000000} value={this.state.sitePlanAmount} onChange={this.onInputPlanAmount} /></Col>
                                    <Col span={8}>
                                        <a href="javascript:void(0)" onClick={this.editSitePlan}>{sitePlanIsEdit == true ? '保存' : '修改'}</a>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row type="flex" justify="space-around" align="bottom" className='row3'>
                            <Col span={4} offset={4} style={{ paddingBottom: 8 }}>实际随机（入组）数</Col>
                            <Col span={16}>
                                <Row>
                                    <Col span={10}>-</Col>
                                    <Col span={6}>{this.state.actualAmount}</Col>
                                </Row>
                            </Col>
                        </Row>
                        {!isGivenSecondLines && <Row type="flex" justify="space-around" align="bottom" className='row3'>
                    <Col span={4} offset={4} style={{ paddingBottom: 8 }}>入组周期</Col>
                    <Col span={16}>
                        <Row>
                            <Col span={10}>
                                {`${plan.batchLeftYear || '-' }-${plan.batchLeftMonth || '-'} ~ ${plan.batchRightYear || '-'}-${plan.batchRightMonth || '-'}`}       
                             </Col>
                            <Col span={6}>{!isGivenSecondLines && <InputNumber value={plan.batchPlanAmount || 0} precision={0} onChange={this.onInputBatchPlanAmount} />}</Col>
                            <Col span={8}>{!isGivenSecondLines && <Button type="primary" onClick={this.addUpdateMonthly}>更新</Button>}</Col>
                                </Row>
                            </Col>
                        </Row>}
                        <Row type="flex" justify="space-around" align="top" className='row2'>
                            <Col span={4} offset={4}>
                            </Col>
                            <Col span={16}>
                                {
                                    siteMonthlyPlan.map((monthlyPlan, i) => (
                                        <Row key={i}>
                                            <Col span={10}>{monthlyPlan.yearMonth}</Col>
                                            <Col span={6}><InputNumber disabled={!monthlyPlan.editing} min={0} max={100000000} value={monthlyPlan.planAmount} onChange={this.onInputMonthlyPlanAmount.bind(this, i)} /></Col>
                                            {/* <Col span={8}>
                                                {
                                                  this.state[`loading${i}`] ? <Spin size="small" spinning={true}></Spin> : <a onClick={() => this.saveDefinePlan(i)}>{monthlyPlan.editing == true ? '保存' : '修改'}</a>
                                                }
                                            </Col> */}
                                        </Row>
                                    ))
                                }
                            </Col>
                        </Row>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default SitePlanModal;


// WEBPACK FOOTER //
// ./src/components/plan/SitePlanModal.js